import React from "react";
import { Col, Row } from "react-bootstrap";
import { evidenceTypes, evidenceTypesObj } from "./CONSTANTS";
import EvidencePreview from "./EvidencePreview";

const EvidenceDetailsInfo = ({ type, description, file, viewFormat, isDocuments, isDocumentObj }) => !viewFormat ? (
    <ul style={{ listStyle: "none" }} className="pt-1 border-top">
        <li>
            <span className="txtgrey">Type:</span>
            <span className="rightData">{isDocuments ? type : isDocumentObj ? evidenceTypesObj[type] : evidenceTypes[type]}</span>
        </li>
        <li>
            <span className="txtgrey">Description:</span>
            <span className="rightData">{description}</span>
        </li>
        <li>
            <span className="txtgrey">Preview:</span>
            <span className="rightData">{file ? <EvidencePreview type={type} file={file} /> : null}</span>
        </li>
    </ul>
) : (
    <Row>
        <Col lg={4}>
            <div className="form-group viewbox">
                <h5>Type</h5>
                <p className="rightData">{isDocumentObj ? evidenceTypesObj[type] : evidenceTypes[type]}</p>
            </div>
        </Col>
        <Col lg={4}>
            <div className="form-group viewbox">
                <h5>Description</h5>
                <p className="rightData">{description}</p>
            </div>
        </Col>
        <Col lg={4}>
            <div className="form-group viewbox">
                <h5>Preview</h5>
                <p className="rightData">{file ? <EvidencePreview type={type} file={file} /> : null}</p>
            </div>
        </Col>
    </Row>
);

export default EvidenceDetailsInfo;
